import { useState, useEffect, useContext, useRef } from 'react'
import { useDispatch, useStore } from 'react-redux'
import moment from 'moment-timezone';
import { MdOutlineArrowBackIosNew } from 'react-icons/md'
import { useHistory, useLocation } from 'react-router-dom'
import { Table, Modal, Progress } from 'rsuite'
import { MdDownload } from 'react-icons/md';
import { FaCheck } from 'react-icons/fa';

import ListInfoModal from './listInformationModal'
import MarkCompleteModal from './listInformationModal/mark-complete-modal'
import VendorExportModal from '../AssignVendorComponent/modals/export-modal'
import { checkQaPendingListSuppliers, getListDetails, getListSuppliers, getListsData, getListsTotalSpend, getSuppliersDataByIds, pauseOrResumeSequencingToListId, rerunUnmatchedListSuppliers, stopOrResumeSequencing, getListSupplierCountByListId } from '../../redux/actions/vendor'
import ContextMenu from '../CommonComponents/ContextMenu'
import SendToCallsModal from './callsComponent/sendToCallsModal'
import FilterComponent from './listInformationModal/filter-component'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import { toast } from '../CommonComponents/ToastComponent/toast'
import { getExportListReportData } from '../../services/exportListReport'
import AddCallerDetails from './callsComponent/addCallerDetails'
import { getAbbreviatedState, getChunkSizes, getTimezoneByState } from '../../services/helper'
import InSequenceComponent from './callsComponent/inSequenceComponent'
import { getInCallsListSuppliers } from '../../redux/actions/caller'
import { checkIsAdminOrModerator } from '../../services/helper'
import { WebSocketContext } from '../../hooks/useWebSocket';
import { deleteFailedListbyId } from '../../redux/actions/upload';
import ModalComponent from '../CommonComponents/Modal';
import PartnerSubmission from './partnerSubmission';

const { Column, HeaderCell, Cell, Pagination } = Table

export const LinkCell = ({ rowData, dataKey, onClick, ...props }) => {
    if (dataKey === 'isPausedSequencing') {
        return (<Cell {...props} role="button" className="table-link list-table-cell text-black" id={rowData.id} onClick={() => onClick(rowData.id)} >
            {rowData?.isStoppedSequencing ? 'Stopped' : rowData?.isPausedSequencing ? 'Paused' : ''}
        </Cell>)
    } else {
        return (
            <Cell {...props} role="button" className="table-link list-table-cell text-black" id={rowData.id} onClick={() => onClick(rowData.id)} >
                <button style={{ width: '60px' }} className={`h4 mb-0 text-start`}>
                    {rowData[dataKey]}
                </button>
            </Cell>
        )
    }

}

export const CallCell = ({ rowData, dataKey, onClick, btnText, bgClass = '', customClass = '', ...props }) => {
    return (
        <Cell {...props} role="button" className="table-action">
            {btnText === 'Link to Vendor' ?
                <div className="table-action d-flex gap-2">
                    <div className="button ps-0 pe-0">
                        <button type="button" className={`h4 mb-0 bg-red text-white rounded pt-2 pb-2 p-4`}>{'Remove Call Details'}</button>
                    </div>
                    <div className="button ps-0 pe-0">
                        <button type="button" className={`h4 mb-0 text-white rounded pt-2 pb-2 p-4 ${bgClass} ${customClass}`}>{btnText}</button>
                    </div>
                    <div className="button ps-0 pe-0">
                        <button type="button" className={`h4 mb-0 bg-blue text-white rounded pt-2 pb-2 p-4`}>{'Edit'}</button>
                    </div>
                </div>
                :
                <div className="button ps-0 pe-0">
                    <button type="button" className={`h4 mb-0 text-white rounded pt-2 pb-2 p-4 ${bgClass} ${customClass}`} onClick={() => onClick(rowData?.id)}>{btnText}</button>
                </div>
            }
        </Cell>
    )
}

export const TableCell = ({ rowData, dataKey, onClick, ...props }) => {
    let cellData = rowData?.[dataKey] || ''
    if (dataKey === 'state' && rowData[dataKey]) {
        cellData = getAbbreviatedState('', rowData[dataKey])
    } else if (dataKey === 'dateSubmitted') {
        const importedDate = rowData?.['dateSubmitted'] ? moment(rowData?.['dateSubmitted']).format('MM/DD/YYYY') : '';
        cellData = importedDate
    } else if (dataKey === 'partnerName') {
        cellData = rowData['partner']?.partnerName
    }
    return (
        <Cell {...props} className="table-link list-table-cell text-black" id={rowData.id} title={rowData[dataKey]}>
            {cellData}
        </Cell>
    )
}

const MyListsComponent = () => {
    const store = useStore().getState()
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation();
    const {
        domain: {
            currentDomain,
        },
        vendor: { allSuppliers },
        app: { listExportColumns, supplierMatchColumns, paymentOptimizationColumns, rwConfigurationColumns },
        user: { callerUsers },
        caller: { incomingCall },
        auth: { user }
    } = store

    const isAdminOrMod = checkIsAdminOrModerator(currentDomain)
    const currentStatuses = [
        {
            "label": "Match Pending",
            "value": "Match Pending"
        },
        {
            "label": "Unmatched - Pending QA",
            "value": "Unmatched - Pending QA"
        },
        {
            "label": "Match in Progress",
            "value": "Match in Progress"
        },
        {
            "label": "Matched - Pending QA",
            "value": "Matched - Pending QA"
        },
        {
            "label": "In Sequence",
            "value": "In Sequence"
        },
        {
            "label": "Acceptance QA Pending",
            "value": "Acceptance QA Pending"
        }
    ]

    let filterColumns = [
        { label: 'Partner Name', name: 'partnerName', options: [] },
        { label: 'Customer Name', name: 'customerName', options: [] },
        { label: 'Status', name: 'status', options: ['Match in Progress', 'Matching Complete', 'Match Marked Complete'] },
        { label: 'Date Imported', name: 'dateSubmitted' }
    ]

    const callFilterColumns = [
        { label: 'Partner Name', name: 'partnerName', options: [] },
        { label: 'Customer Name', name: 'customerName', options: [] },
        { label: 'Supplier Name', name: 'suppliername', options: [] },
        { label: 'Status ', name: 'status', options: ['In Calls', 'In Qa'] },
        { label: 'Caller Assigned', name: 'callerAssigned', options: [] }
    ]

    const reenablementFilterColumns = [
        { label: 'Supplier Name', name: 'suppliername', options: [] },
        { label: 'Status ', name: 'status', options: ['In Calls', 'In Qa'] },
        { label: 'Caller Assigned', name: 'callerAssigned', options: [] }
    ]

    const partnerSubmissionFilterColumns = [
        { label: 'Partner Name', name: 'partnerId', options: [] },
        { label: 'Status ', name: 'currentStatus', options: ['Match Pending', 'Match in Progress', 'Unmatched - Pending QA', 'Matched - Pending QA', 'Match Complete', 'In Sequence', 'Acceptance QA Pending', 'Acceptance Complete'], isMulti: true },
        { label: 'Date Imported', name: 'createdAt' },
        { label: 'Campaign', name: 'campaignType', options: ['match', 'campaign', 'recampaign', 'no campaign', 'user halted campaign'] }
    ]


    const { socketIo } = useContext(WebSocketContext)
    const partnerSubRef = useRef(null)
    const [uploadingLists, setUploadingLists] = useState({})
    const [listStatus, setListStatus] = useState({});
    const [openModal, setOpenModal] = useState(false)
    const [showReRunModal, setShowReRunModal] = useState(false)
    const [reRunListSuppliers, setReRunListSuppliers] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadingLists, setIsLoadingLists] = useState(false)
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [sequenceLimit, setSequenceLimit] = useState(10)
    const [sequencePage, setSequencePage] = useState(1)
    const [unlinkedVendorsLimit, setUnlinkedVendorsLimit] = useState(10)
    const [unlinkedVendorsPage, setUnlinkedVendorsPage] = useState(1)
    const [listTableData, setListTableData] = useState([])
    const [totalLists, setTotalLists] = useState([])
    const [totalInCallsData, setTotalInCallsData] = useState(0)
    const [isLoadingCallsData, setIsLoadingCallsData] = useState(false)
    const [oldCallsTableData, setoldCallsTableData] = useState([])
    const [callsTableData, setCallsTableData] = useState([])
    const [reenablementTableData, setReenablementTableData] = useState([])
    const [showListInfoModal, setShowListInfoModal] = useState(false)
    const [selectedCompany, setSelectedCompany] = useState([])
    const [isShowMarkCompleteModal, setIsShowMarkCompleteModal] = useState(false)
    const [showExportModal, setShowExportModal] = useState(false)
    const [exportData, setExportData] = useState([])
    const [exportFileName, setExportFileName] = useState('')
    const [showContextMenu, setShowContextMenu] = useState(false)
    const [currentTab, setCurrentTab] = useState('list')
    const [showSendToCallsModal, setShowSendToCallsModal] = useState(false)
    const [showFilters, setShowFilters] = useState(false)
    const [listFilters, setListFilters] = useState({})
    const [inCallsFilters, setInCallsFilters] = useState({})
    const [partnerSubFilters, setPartnerSubFilters] = useState({
        'currentStatus': currentStatuses
    })
    const [inReenablementFilters, setInReenablementFilters] = useState({})
    const [listFilterColumns, setListFilterColumns] = useState(filterColumns)
    const [callsFilterColumns, setCallsFilterColumns] = useState(callFilterColumns)
    const [reenablementFilterColumn, setReenablementFilterColumn] = useState(reenablementFilterColumns)
    const [partnerSubFilterColumns, setPartnerSubFilterColumns] = useState(partnerSubmissionFilterColumns)
    const [isFilterApplied, setIsFilterApplied] = useState(false)
    const [showAddCallerDetails, setShowAddCallerDetails] = useState(false)
    const [showQaCallerDetails, setShowQaCallerDetails] = useState(false)
    const [selectedVendorId, setSelectedVendorId] = useState(null)
    const [matchedSupplierId, setMatchedSupplierId] = useState(null)
    const [selectedVendorInCallsData, setSelectedVendorInCallsData] = useState({})
    const [isEditUnlinkedCalls, setIsEditUnlinkedCalls] = useState(false)
    const [vendorInCallsDetailsId, setVendorInCallsDetailsId] = useState(null)
    const [isDeleteList, setIsDeleteList] = useState(false)
    const [errorLogForList, setErrorLogForList] = useState({ listId: null, logs: [] })
    const [isFromMarkListComplete, setIsFromMarkListComplete] = useState(false)
    const [showStopModal, setShowStopModal] = useState(false)
    const [activeKey, setActiveKey] = useState('generalCalls');
    const [filterSelected, setFilterSelected] = useState('')
    const [selectedOption, setSelectedOption] = useState({
        value: 'export',
        label: 'Export Results'
    })
    const [selectedVendorCompanyName, setSelectedVendorCompanyName] = useState('')
    const [stopSequencingNote, setStopSequencingNote] = useState('')
    const [showReportDownloadModal, setShowReportDownloadModal] = useState(false)
    const [downloadListData, setDownloadListData] = useState([]);
    const [downloadIndex, setDownloadIndex] = useState();
    const [supplierPassedFromNotification, setSupplierPassedFromNotification] = useState(null);


    const tabs = [
        { label: 'Lists', value: 'list' },
        { label: 'In Sequence', value: 'sequence' },
        { label: 'Partner Submissions', value: 'partnerSubmissions' }
    ]

    const dbMatchTableColumns = [
        { name: 'partnerName', label: 'Partner Name' },
        { name: 'companyName', label: 'Customer Name' },
        { name: 'isPausedSequencing', label: 'Sequencing' },
        { name: 'status', label: 'Status' },
        { name: 'totalSuppliers', label: 'Total Suppliers' },
        { name: 'suppliersMatched', label: '# Suppliers Matched' },
        { name: 'suppliersContacted', label: '# Suppliers Contacted' },
        { name: 'totalApSpend', label: 'Total AP Spend' },
        { name: 'dateSubmitted', label: 'Date Imported' },
    ]

    const selectOptions = [
        {
            value: 'exportParent', label: 'Export Results',
            children: [
                {
                    label: 'Supplier Match Preview',
                    value: 'supplierMatch'
                },
                {
                    label: 'Payment Optimization Report',
                    value: 'paymentOptimization'
                },
                {
                    label: 'RW Configuration Report',
                    value: 'rwConfiguration'
                },
                {
                    label: 'Legacy Results Report',
                    value: 'export'
                }
            ]
        },
        { value: 'markCallsComplete', label: 'Mark Calls as Complete' },
        { value: 'rerun', label: 'Rerun Matching' },
        { value: 'sendToCalls', label: 'Send to Calls' },
    ]

    const addSelectOptionIfAdminOrModerator = [
        { value: 'pause', label: 'Pause Sequencing' },
        { value: 'stop', label: 'Stop Sequencing' },
    ]

    const sendToCallsColumns = [
        { name: 'suppliername', label: 'Supplier Name' },
        { name: 'state', label: 'State' },
        // { name: 'country', label: 'Country' },
        { name: 'spend', label: 'Spend' },
        // { name: 'paymentCount', label: 'Payment Count' },
    ]

    const callsTableColumns = [
        { name: 'companyName', label: 'Customer Name' },
        { name: 'suppliername', label: 'Supplier Name' },
        { name: 'status', label: 'Status' },
        { name: 'callerAssigned', label: 'Caller Assigned' },
        { name: 'dateMovedToCalls', label: 'Date Moved to Calls' },
        { name: 'lastCalledDate', label: 'Last Time Called' },
        { name: 'calls', label: 'Calls' },
        { name: 'emails', label: 'Emails' },
        { name: 'spend', label: 'Spend' },
        { name: 'state', label: 'State' },
        { name: 'timezone', label: 'Timezone' },
        { name: 'localTime', label: 'Local Time' }
    ]

    const reenablementTableColumns = [
        { name: 'suppliername', label: 'Supplier Name', sortable: true },
        { name: 'acceptsCard', label: 'Accepts Card', sortable: true },
        { name: 'lastAcceptanceDate', label: 'Last Acceptance Date', sortable: true },
        { name: 'state', label: 'State', sortable: true },
        { name: 'childSupplierCount', label: 'Child Supplier', sortable: false },
        { name: 'spend', label: 'Total Spend', sortable: true }
    ]

    const unlinkedVendorsTableColumns = [
        { name: 'caller', label: 'Caller' },
        { name: 'assumedVendorName', label: 'Assumed Supplier Name' },
        { name: 'contactName', label: 'Contact Name' },
        { name: 'dateWhenCalled', label: 'Date Called' }
    ]

    const timezoneMapping = {
        AEST: 'Australia/Sydney',
        ACST: 'Australia/Adelaide',
        AWST: 'Australia/Perth',
        AST: 'America/Halifax',
        NST: 'America/St_Johns',
        EST: 'America/New_York',
        CST: 'America/Chicago',
        MST: 'America/Denver',
        PST: 'America/Los_Angeles',
        EST: 'America/New_York',
        CST: 'America/Chicago',
        MST: 'America/Denver',
        PST: 'America/Los_Angeles',
        AKST: 'America/Anchorage',
        HST: 'Pacific/Honolulu',
        CET: 'Europe/Berlin',
    };

    if ((currentDomain?.roleId === 2 || currentDomain?.roleName !== 'moderator') || (currentDomain?.roleId === 3 || currentDomain?.roleName !== 'admin')) { // add markComplete 
        selectOptions.splice(1, 0, {
            value: 'markComplete',
            label: 'Mark Matching as Complete'
        })
    }

    let last_dt = moment().format().split('T')[0];
    let st_dt = moment().subtract(1, 'months').format().split('T')[0]

    const handleChangeLimit = (dataKey, type = 'list') => {
        type === 'list' ? setPage(1) : type === 'imported' ? setSequencePage(1) : setUnlinkedVendorsLimit(1);
        type === 'list' ? setLimit(dataKey) : type === 'imported' ? setSequenceLimit(dataKey) : setUnlinkedVendorsPage(1);
    }

    const handleCompanyNameClick = (companyId) => {
        let selectedCompany = [];
        selectedCompany = listTableData.find(row => row.id === companyId)
        setSelectedCompany([selectedCompany])
        setShowListInfoModal(true)
    }

    const headerElements = (columns) => {
        return columns.map((col, index) => {
            if (index === 1 || index === 2) {
                return (
                    <Column
                        resizable
                        width={200}
                        sortable
                        key={col.name}
                    >
                        <HeaderCell className='fw-bold text-black' title={col.label}>{col.label}</HeaderCell>
                        <LinkCell dataKey={col.name} onClick={handleCompanyNameClick} />
                    </Column>
                )
            }
            return (
                <Column
                    resizable
                    sortable
                    key={col.name}
                >
                    <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                    <TableCell className='text-black' dataKey={col.name} />
                </Column>
            )
        })
    }

    const handleClose = (isRefreshListsData = false) => {
        history.push('/lists')
        let isMatchingLists = listTableData?.filter((list) => list?.status.toLowerCase() === 'match in progress')
        if ((isRefreshListsData) || (isMatchingLists && isMatchingLists.length > 0)) {
            getListSuppliersData(limit, limit * (page - 1), listFilters)
        } else {
            isRefreshListsData && setPage(1)
        }
        setShowListInfoModal(false)
    }

    const showContextMenuItems = () => {
        let listTable = document.getElementById('my-list-table')
        if (listTable) {
            listTable.oncontextmenu = function (e) {
                e.preventDefault()
                const parentWithClass = e.target.closest('.rs-table-row .list-table-cell');
                const rowId = parseInt(parentWithClass.id)
                const rowData = listTableData.find((list) => list?.id === rowId)
                if (rowData?.status && rowData?.status.toLowerCase() === 'match in progress') {
                    toast.show({
                        title: 'Danger',
                        description: 'The selected List DB Match is currently in progress!',
                        duration: 1000
                    })
                    setShowContextMenu(false)
                    setSelectedCompany([])
                    return
                } else {
                    setShowContextMenu(true)
                    setSelectedCompany([rowData])
                }
            }
        }
    }

    const stopOrResumeListHandler = async (value) => {
        await dispatch(stopOrResumeSequencing({ listSupplierId: null, note: '', operation: value, listId: selectedCompany?.[0]?.id })).then((res) => {
            setShowStopModal(false)
            toast.show({
                title: 'Success',
                description: `List ${value === "stop" ? 'Stopped' : 'Resumed'} Successfully`,
            })
            let filters = currentTab === 'list' ? listFilters : currentTab === 'sequence' ? inCallsFilters : partnerSubFilters
            getListSuppliersData(limit, limit * (page - 1), filters)

        }).catch(() => {
            toast.show({
                title: 'Danger',
                description: `Unable To ${value === "stop" ? 'Stopped' : 'Resumed'} `,
            })
        })
    }

    const handleMenuItemClick = async (value) => {
        setShowContextMenu(false)

        if (value?.value === 'markComplete' || value?.value === 'sendToCalls') {
            if (value?.value === 'markComplete') {
                setIsLoadingLists(true)
                let qaCount = 0
                await dispatch(checkQaPendingListSuppliers(selectedCompany?.[0]?.id)).then((res) => {
                    qaCount = res?.count || 0
                    setIsLoadingLists(false)
                }).catch(() => {
                    setIsLoadingLists(false)
                })

                if (qaCount > 0) {
                    toast.show({
                        title: 'Danger',
                        description: 'There are pending matched list suppliers in QA!'
                    })
                    return
                }

                if (selectedCompany?.[0]?.status.toLowerCase() === 'match marked complete') {
                    toast.show({
                        title: 'Danger',
                        description: 'This List already marked completed!'
                    })
                    return
                }
            }
            if (selectedCompany?.[0]?.status.toLowerCase() === 'failed') {
                toast.show({
                    title: 'Danger',
                    description: 'This List already failed'
                })
                return
            } else if (selectedCompany?.[0]?.status.toLowerCase() === 'mark matching complete in progress') {
                toast.show({
                    title: 'Danger',
                    description: 'This List Mark Matching Complete Is In Progress'
                })
                return
            }
            if (value?.value === 'sendToCalls') {
                setShowSendToCallsModal(true)
            } else {
                setIsShowMarkCompleteModal(true)
            }
        } else if (value?.value === 'rerun') {
            onRerunMatching()
        } else if (value?.value === "pause" || value?.value === "unpause") {
            await dispatch(pauseOrResumeSequencingToListId({ listId: selectedCompany[0]?.id, operation: value?.value === "pause" ? "pauseSequencing" : "resumeSequence" })).then((res) => {
                let filters = currentTab === 'list' ? listFilters : currentTab === 'sequence' ? inCallsFilters : partnerSubFilters
                getListSuppliersData(limit, limit * (page - 1), filters)
                toast.show({
                    title: 'Success',
                    description: `List ${value?.value === "pause" ? 'Paused' : 'Resumed'} Successfully`,
                })
            })
        } else if (value?.value === 'stop') {
            setShowStopModal(true)
        } else if (value.value === 'resume') {
            stopOrResumeListHandler(value.value)
        } else if (value?.value === 'supplierMatch' || value?.value === 'paymentOptimization' || value?.value === 'rwConfiguration' || value?.value === 'export') {
            setSelectedOption({
                value: value?.value,
                label: value?.label
            })
            const total = await dispatch(getListSupplierCountByListId({ listId: selectedCompany[0]?.id }))
            const chunkSize = 20000;
            if (total?.count <= chunkSize) {
                handleOpenVendor({ offset: 0, limit: chunkSize, index: 0, selectedValue: value?.value })
            } else {
                const chunks = await getChunkSizes(total, chunkSize, selectedCompany);
                setDownloadListData(chunks);
                setShowReportDownloadModal(true);
            }
        }
    }
    const handleExportClose = async (status = false) => {
        if (status) {
            if (downloadListData[downloadIndex]) {
                const updatedList = [...downloadListData];
                updatedList[downloadIndex] = {
                    ...updatedList[downloadIndex],
                    isDownloaded: true,
                };
                setDownloadListData(updatedList);
            }
        }
        setShowExportModal(false);
        setExportData([]);
        setExportFileName('');
    }

    const handleOpenVendor = async ({ offset, limit, index, selectedValue }) => {
        setDownloadIndex(index);
        setShowExportModal(true);
        const company = selectedCompany?.[0];
        let exportData;
        const value = selectedValue ? selectedValue : selectedOption?.value;
        if (value === 'supplierMatch') {
            exportData = await getExportListReportData(supplierMatchColumns, company, dispatch, value, offset, limit);
            setExportFileName(value + "_" + company?.companyName + "_company");
        } else if (value === 'paymentOptimization') {
            exportData = await getExportListReportData(paymentOptimizationColumns, company, dispatch, value, offset, limit);
            setExportFileName(value + "_" + company?.companyName + "_company");
        } else if (value === 'rwConfiguration') {
            exportData = await getExportListReportData(rwConfigurationColumns, company, dispatch, value, offset, limit);
            setExportFileName(value + "_" + company?.companyName + "_company");
        } else if (value === 'export') {
            exportData = await getExportListReportData(listExportColumns, company, dispatch, '', offset, limit);
            setExportFileName(value + "_" + company?.companyName + "_company");
        }
        setExportData(exportData);
    };

    const handleCloseModal = () => setShowReportDownloadModal(false);

    const handleClickTab = (tab) => {
        setCurrentTab(tab)
        if (tab !== 'list') {
            setIsFilterApplied(false)
        }
    }

    const handleAddFilterClick = () => {
        let filters = currentTab === 'list' ? listFilters : currentTab === 'sequence' ? inCallsFilters : partnerSubFilters
        setShowFilters(!showFilters)
        if (!isFilterApplied) {
            setListFilters({})
            setInCallsFilters({})
            setInReenablementFilters({})
        }
        if (Object.keys(filters).length === 0 && isFilterApplied) {
            setIsFilterApplied(false)
            if (page === 1) {
                getListSuppliersData(limit, limit * (page - 1), filters)
            } else {
                setPage(1)
            }
        }
    }

    const handleFiltersChange = (value, optionName) => {
        if (!value) {
            if (currentTab === 'list') {
                let filterValues = { ...listFilters }
                if (optionName === 'date') {
                    delete filterValues?.['start_date']
                    delete filterValues?.['end_date']
                } else {
                    delete filterValues?.[optionName]
                }
                setListFilters(filterValues)
            } else if (currentTab === 'sequence') {
                if (activeKey === 'generalCalls') {
                    let filterValues = { ...inCallsFilters }
                    delete filterValues?.[optionName]
                    setInCallsFilters(filterValues)
                } else {
                    let filterValues = { ...inReenablementFilters }
                    delete filterValues?.[optionName]
                    setInReenablementFilters(filterValues)
                }
            } else {
                let filterValues = { ...partnerSubFilters }
                delete filterValues?.[optionName]
                setPartnerSubFilters(filterValues)
            }
        } else {
            if (currentTab === 'list') {
                if (optionName === 'date') {
                    setListFilters({
                        ...listFilters,
                        start_date: value,
                        end_date: value
                    })
                } else {
                    setListFilters({
                        ...listFilters,
                        [optionName]: value
                    })
                }
            } else if (currentTab === 'sequence') {
                if (activeKey === 'generalCalls') {
                    setInCallsFilters({
                        ...inCallsFilters,
                        [optionName]: value
                    })
                } else if (activeKey !== 'generalCalls') {
                    setInReenablementFilters({
                        ...inReenablementFilters,
                        [optionName]: value
                    })
                }
            } else {
                if (optionName === 'currentStatus') {
                    setPartnerSubFilters({
                        ...partnerSubFilters,
                        [optionName]: value,
                    })
                } else if (optionName === 'date') {
                    setPartnerSubFilters({
                        ...partnerSubFilters,
                        start_date: value,
                        end_date: value
                    })
                } else {
                    setPartnerSubFilters({
                        ...partnerSubFilters,
                        [optionName]: value
                    })
                }
            }
        }
    }

    const handleCancelClick = () => {
        if (Object.keys(listFilters).length > 0 || Object.keys(inCallsFilters).length > 0) {
            setListFilters({})
            setInCallsFilters({})
            setInReenablementFilters({})
            setPartnerSubFilters({})
        } else {
            setShowFilters(false)
        }
    }

    const filterSuppliers = (dataArray, filters) => {
        return dataArray.filter(item => {
            const supplierNameMatch = filters.suppliername
                ? item.suppliername?.trim()?.toLowerCase().includes(filters.suppliername.toLowerCase()?.trim())
                : true;

            const partnerNameMatch = filters.partnerName
                ? item?.list?.partner?.partnerName?.trim()?.toLowerCase().includes(filters.partnerName?.trim()?.toLowerCase())
                : true;

            const companyNameMatch = filters.customerName
                ? item?.list?.companyName?.toLowerCase()?.trim().includes(filters?.customerName?.toLowerCase()?.trim())
                : true;

            const statusMatch = filters.status
                ? item.vendorsInCall?.status?.trim()?.toLowerCase() === filters.status?.trim()?.toLowerCase()
                : true;

            const callerAssignedMatch = filters.callerAssigned !== undefined
                ? item.vendorsInCall?.callerAssigned === filters.callerAssigned?.value
                : true;

            return supplierNameMatch && partnerNameMatch && companyNameMatch && statusMatch && callerAssignedMatch;
        });
    }

    const handleApplyFilterClick = () => {
        setShowFilters(!showFilters)
        let filters = currentTab === 'list' ? listFilters : currentTab === 'sequence' ? inCallsFilters : partnerSubFilters
        setIsFilterApplied(true)

        if (currentTab === 'list') {
            if (page === 1) {
                getListSuppliersData(limit, limit * (page - 1), filters)
            } else {
                setPage(1)
            }
        } else if (currentTab === 'sequence') {
            let tmpFilterData = filterSuppliers(oldCallsTableData, inCallsFilters)
            setCallsTableData(tmpFilterData)
            setTotalInCallsData(tmpFilterData?.length)
        } else {
            if (partnerSubRef && partnerSubRef?.current) {
                partnerSubRef?.current?.getTableData({ filters })
            }
        }
    }
    const handleResetFilterClick = () => {
        let filters = currentTab === 'list' ? listFilters : inCallsFilters
        if (Object.keys(filters).length > 0 || isFilterApplied) {
            setListFilters({})
            setInCallsFilters({})
            setInReenablementFilters({})
            setPartnerSubFilters({})
            setIsFilterApplied(false)
            if (currentTab === 'list') {
                if (page === 1) {
                    getListSuppliersData(limit, limit * (page - 1), {})
                } else {
                    setPage(1)
                }
            } else if (currentTab === 'sequence') {
                setCallsTableData(oldCallsTableData)
                setTotalInCallsData(oldCallsTableData?.length)
            } else {
                if (partnerSubRef && partnerSubRef?.current) {
                    partnerSubRef?.current?.getTableData({})
                }
            }
        }
    }

    const getListSuppliersData = async (limit, offset, filterData) => {
        setIsLoadingLists(true)
        await dispatch(getListsData({
            limit: limit,
            offset: offset,
            filterData
        })).then(async (res) => {
            let listResults = res?.lists
            let logs = res?.logs
            let partners = res?.partners
            let mainList = listResults?.map((listRecord) => {
                let tmpPartner = partners?.filter(partner => partner?.id === listRecord?.partnerId)[0]
                let tmpLogs = logs?.filter(log => log?.listId === listRecord?.id)
                listRecord['partner'] = tmpPartner
                listRecord['logs'] = tmpLogs
                return listRecord
            })

            let listIds = mainList?.length ? mainList?.map((list) => { return list?.id }) : []
            let listDetails = listIds?.length ? await dispatch(getListDetails(listIds)).then(res => {
                return res
            }) : []
            let listsSpend = listIds?.length ? await dispatch(getListsTotalSpend(listIds)).then(res => {
                return res
            }) : []

            for (let i = 0; i < mainList?.length; i++) {
                let listItem = mainList[i];
                let pausedSupCount = listDetails?.totalPausedLs?.find(listSup => listSup?.listId === listItem?.id)?.count || 0;
                let totalSuppliers = listDetails?.totalListSuppliers?.find(listSup => listSup?.listId === listItem?.id)?.count || 0;
                let suppliersMatched = listDetails?.totalMatchedListSuppliers?.find(listSup => listSup?.listId === listItem?.id)?.count || 0;
                let totalApSpend = Math.round(listsSpend?.spendPerList?.find(list => list?.listId === listItem?.id)?.totalApSpend) || 0;
                totalApSpend = totalApSpend ? Number(totalApSpend).toLocaleString() : totalApSpend;

                listItem['pausedSupCount'] = pausedSupCount;
                listItem['suppliersMatched'] = suppliersMatched;
                listItem['totalApSpend'] = '$ ' + totalApSpend;
                listItem['totalSuppliersCreated'] = totalSuppliers;

                // Main progress (existing logic)
                listItem['progress'] = parseInt((parseInt(totalSuppliers) / parseInt(listItem?.totalSuppliers)) * 100);

                // New autoMasterCreateProgress logic
                const autoTotal = parseInt(listItem.autoMasterCreateTotalCount || 0);
                const autoProgress = parseInt(listItem.autoMasterCreateProgressCount || 0);

                if (autoTotal > 0) {
                    const autoProgressPercent = (autoProgress / autoTotal) * 100;
                    if (autoProgressPercent < 100) {
                        listItem['autoMasterCreateProgress'] = autoProgressPercent;
                    }
                }
            }
            setListTableData(mainList)
            let tmpCols = [...listFilterColumns]
            let callsCols = [...callsFilterColumns]
            let reenablementCols = [...reenablementFilterColumn]
            let partnerSubCols = [...partnerSubmissionFilterColumns]
            setListFilterColumns(tmpCols)
            setCallsFilterColumns(callsCols)
            setReenablementFilterColumn(reenablementCols)
            setPartnerSubFilterColumns(partnerSubCols)
            setTotalLists(res?.count)
            setIsLoadingLists(false)
            return mainList
        }).catch(() => {
            setIsLoadingLists(false)
        })
    }

    const getInSequenceSuppliersData = (sequenceFilters) => {
        setIsLoadingCallsData(true)
        setFilterSelected(sequenceFilters)
        if (activeKey === 'generalCalls') {
            dispatch(getInCallsListSuppliers(sequenceFilters, !isAdminOrMod ? user?.id : '')).then(async (result) => {
                let matchedSuppliersData = []
                let matchedSuppliersDataIds = []
                let mastersData = []
                let childMasterIds = []
                let childMasterData = []
                let locationMasterIds = []
                let locationMasterData = []
                let locationSupMasterIds = []
                const matchedSupplierIds = result?.filter(data => data?.matchedSupplierId)?.map(data => data?.matchedSupplierId) //all matched Supplier ids
                const uniqueMatchedSupplierIds = [...new Set(matchedSupplierIds)] //unique matched supplier ids 
                if (uniqueMatchedSupplierIds && uniqueMatchedSupplierIds?.length > 0) {
                    await dispatch(getSuppliersDataByIds(uniqueMatchedSupplierIds)).then((res) => {  // all matched suppliers data (child, location, master)
                        matchedSuppliersDataIds = res?.map(data => data?.id)  // all matched suppliers id (child, location, master)
                        matchedSuppliersData = res      // all matched suppliers data (child, location, master)
                        childMasterIds = res?.filter(data => !data?.isMaster)?.map(data => data?.masterId)   //child master ids 
                        locationSupMasterIds = res?.filter(sup => sup?.isMaster && sup?.masterId && sup?.primaryMasterId)?.map(data => data?.masterId) //location's master ids 
                        locationMasterIds = res?.filter(sup => sup?.isMaster && sup?.masterId && sup?.primaryMasterId)?.map(data => data?.id) // location id
                        mastersData = res?.filter(data => !childMasterIds?.includes(data?.masterId) && !locationMasterIds?.includes(data?.id))
                    })
                }

                if (childMasterIds?.length || locationSupMasterIds?.length) {
                    const ids = [...childMasterIds, ...locationSupMasterIds]
                    await dispatch(getSuppliersDataByIds(ids)).then((res) => {
                        childMasterData = res
                    })
                }

                if (locationMasterIds?.length) {
                    await dispatch(getSuppliersDataByIds(locationMasterIds)).then((res) => {
                        locationMasterData = res
                    })
                }

                const tmpData = result?.map((data) => {
                    let tmp = []
                    data['newMessage'] = 0

                    if (data?.partnerName === undefined || data?.partnerName === '') {
                        data['partnerName'] = ''
                    }

                    if (!data?.vendorsInCall?.lastCalledDate) {
                        data.vendorsInCall.lastCalledDate = ''
                    }
                    const sup = matchedSuppliersData?.find(obj => obj?.id === data?.matchedSupplierId)
                    if (data?.matchedSupplierId) {
                        if (matchedSuppliersDataIds?.includes(data?.matchedSupplierId)) {
                            if (sup?.isMaster && !sup?.masterId) {
                                tmp = mastersData?.filter((master) => master?.id === data?.matchedSupplierId)
                            } else if (!sup?.isMaster) {
                                tmp = childMasterData?.filter((master) => master?.id === sup?.masterId)
                            } else if (sup?.isMaster && sup?.masterId && sup?.primaryMasterId) {
                                tmp = locationMasterData?.filter((master) => master?.id === data?.matchedSupplierId)
                                if (!tmp[0]?.state) {
                                    tmp = childMasterData?.filter((master) => master?.id === tmp?.[0]?.primaryMasterId)
                                }
                            }
                        }
                    }
                    data['matchedMasterSupplierId'] = sup ? (!sup?.isMaster ? sup?.masterId : sup?.id) : null
                    data['masterData'] = { ...tmp[0] }
                    data['state'] = data?.state ? data?.state : tmp?.length > 0 ? tmp[0]?.abbreviatedState ? tmp[0]?.abbreviatedState : tmp[0]?.state : ''
                    const timezone = getTimezoneByState(getAbbreviatedState('', data?.state))
                    const ianaTimezone = timezoneMapping[timezone?.toUpperCase()];
                    let localtime = ianaTimezone ? moment.tz(ianaTimezone).format('h:mm A, dddd') : ''
                    data['localTime'] = localtime || ''
                    data['updatedTimeZone'] = getTimezoneByState(getAbbreviatedState('', data?.state), data?.zip)
                    return data
                })
                setTotalInCallsData(result?.length)
                setIsLoadingCallsData(false)
                setCallsTableData(tmpData)
                setoldCallsTableData(tmpData)
            }).catch(() => {
                setTotalInCallsData(0)
                setIsLoadingCallsData(false)
                setCallsTableData([])
                setoldCallsTableData([])
            })
        }
    }

    const handleMarkCompleteClose = (isRefreshListsData = false, isSendToSequencing = false) => {
        setIsShowMarkCompleteModal(false)
        if (isSendToSequencing) {
            setIsFromMarkListComplete(true)
            setShowSendToCallsModal(true)
        }
        if (isRefreshListsData) {
            getListSuppliersData(limit, limit * (page - 1), listFilters)
        }
    }
    const handleCallClick = async (vendorId, listId, vendorInCall, type, matchedSupplierId = null) => {
        let list = listTableData.find(list => list.id === listId)
        setSelectedVendorId(vendorId)
        setMatchedSupplierId(matchedSupplierId)
        setSelectedVendorInCallsData(vendorInCall)
        history.push({ pathname: `/lists/insequence/${type === 'qa' ? 'qacallerdetails' : 'addcallerdetails'}/${vendorId}${matchedSupplierId ? `?matchedSupplierId=${matchedSupplierId}` : ''}`, state: { matchedSupplierId: matchedSupplierId, vendorInCall: vendorInCall } })
        if (type === 'qa') {
            setShowQaCallerDetails(true)
        }
        setShowAddCallerDetails(true)
    }

    const SequencePaginatedData = callsTableData?.sort((a, b) => {
    }).slice(sequenceLimit * (sequencePage - 1), sequenceLimit * sequencePage)

    const unlinkedVendorsPaginatedData = callsTableData?.sort((a, b) => {
    }).slice(unlinkedVendorsLimit * (unlinkedVendorsPage - 1), unlinkedVendorsLimit * unlinkedVendorsPage)

    showContextMenuItems()

    const handleAddCallerDetailsClose = (loadInCallsData = false) => {
        if (location.state && location.state?.from) {
            history.push(location.state?.from)
            return;
        }
        // if (!incomingCall) {
        setShowAddCallerDetails(false)
        // }
        setShowQaCallerDetails(false)
        setIsEditUnlinkedCalls(false)
        setSelectedVendorId(null)
        if (loadInCallsData) {
            getInSequenceSuppliersData(inCallsFilters)
        }
        setVendorInCallsDetailsId(null)
    }

    const handleUnlinkedCallsEdit = (callData) => {
        setVendorInCallsDetailsId(callData?.id)
        setSelectedVendorInCallsData(callData?.vendorsInCall)
        setIsEditUnlinkedCalls(true)
        setShowAddCallerDetails(true)
        history.push(`/lists/insequence/editcallerdetails`)
    }

    const closeErrorListModal = () => {
        setOpenModal(false)
    }

    const openModalHandler = (action, failedList) => {
        setOpenModal(true)
        if (action === 'delete') {
            setIsDeleteList(true)
        } else {
            setIsDeleteList(false)
        }
        setErrorLogForList({ listId: failedList?.listId, logs: failedList?.logs })
    }

    const onDeleteFailedList = async (id) => {
        setIsDeleteList(true)
        await dispatch(deleteFailedListbyId(id)).then((res) => {
            setOpenModal(false)
            getListSuppliersData(limit, limit * (page - 1), listFilters);
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: 'Unable to delete!'
            })
        })
    }

    const onRerunMatching = async () => {
        setShowReRunModal(true)
        setIsLoading(true)
        await dispatch(getListSuppliers({
            listId: selectedCompany?.[0]?.id,
            type: 'unmatched',
            limit: null,
            offset: null,
            sortColumn: "suppliername",
            sortType: "asc"
        })).then((res) => {
            if (res?.listSuppliers?.length) {
                setReRunListSuppliers(res?.listSuppliers)
            } else {
                setReRunListSuppliers([])
                toast.show({
                    title: 'Danger',
                    description: 'No unmatched supplier found to rerun the list!'
                })
            }
            setIsLoading(false)
        }).catch(err => {
            setReRunListSuppliers([])
            setIsLoading(false)
        })
    }

    const reRunUnmatchedListSuppliers = async () => {
        if (reRunListSuppliers?.length > 0) {
            setIsLoading(true)
            dispatch(rerunUnmatchedListSuppliers({ data: reRunListSuppliers, listId: selectedCompany?.[0]?.id })).then(() => {
                setShowReRunModal(false)
                setIsLoading(false)
                getListSuppliersData(limit, limit * (page - 1), listFilters);
            }).catch(() => {
                setIsLoading(false)
                toast.show({
                    title: 'Warning',
                    description: 'Failed to rerun list matching!',
                })
            })
        }
    }

    const handleReRunModalClose = () => {
        if (!isLoading) {
            setShowReRunModal(false)
            setReRunListSuppliers([])
        }
    }

    const onSendToCallsModalClose = (isRefreshListsData = false) => {
        setShowSendToCallsModal(false)
        setIsFromMarkListComplete(false)
        if (isRefreshListsData) {
            getListSuppliersData(limit, limit * (page - 1), listFilters)
        }
    }

    const handleGoBackButtonClick = () => {
        if (location.state && location.state?.from) {
            history.push(location.state?.from)
        } else {
            if ((showQaCallerDetails || isEditUnlinkedCalls)) {
                handleAddCallerDetailsClose();
            }
            history.push('/lists/insequence');
        }
        setMatchedSupplierId(null)
    }

    useEffect(() => {
        socketIo.on("client", (arg) => {
            setListStatus(arg)
            if (arg.progress === 100) {
                getListSuppliersData(limit, limit * (page - 1), listFilters);
            }
        });

        socketIo.on("waitingList", (arg) => {
            const tmpLists = { ...uploadingLists }
            const total = arg?.length
            if (total) {
                arg.map((val, ind) => {
                    tmpLists[val?.data?.listid] = `${ind + 1} of ${total}`
                })
            }
            setUploadingLists(tmpLists)
        })

        socketIo.on("failedListDeletion", (arg) => {
            setOpenModal(false)
            if (arg.message === "Deletion completed") {
                getListSuppliersData(limit, limit * (page - 1), listFilters);
            }
        })
    }, [])

    useEffect(() => {
        if (!listStatus || Object.keys(listStatus)?.length === 0) {
            return
        }
        const tmpLists = { ...uploadingLists }
        tmpLists[listStatus?.listid] = listStatus?.progress
        setUploadingLists(tmpLists)
    }, [listStatus])

    useEffect(() => {
        location?.state?.activeKey && setActiveKey(location?.state?.activeKey)
        if (location?.state && location?.state?.IsShowAddCallerDetails) {
            setShowAddCallerDetails(true)
            setSelectedVendorId(location?.state?.vendorId)
            if (!location?.state?.vendorId || location?.state?.vendorId === null) {
                setSelectedVendorInCallsData({})
            } else {
                const vendorInCallData = callsTableData?.find(data => parseInt(data?.id) === parseInt(location?.state?.vendorId))
                const vendorInCall = vendorInCallData?.vendorsInCall
                vendorInCall['partnerName'] = vendorInCallData?.partnerName
                vendorInCall['companyName'] = vendorInCallData?.companyName
                vendorInCall['nameUse'] = vendorInCallData?.list?.nameUse
                vendorInCall['contactName'] = vendorInCallData?.supplierDetail?.contactNameOld ? vendorInCallData?.supplierDetail?.contactNameOld : 'NONE'
                setSelectedVendorInCallsData(vendorInCall)
            }
            history.push({
                pathname: '/lists/insequence/addcallerdetails/' + location?.state?.vendorId,
                state: {
                    IsIncomingCall: true,
                    phoneNumber: location?.state?.phoneNumber,
                    isRedirected: true,
                    matchedSupplier: location?.state?.matchedSupplier,
                    callerId: location?.state?.callerId,
                    supName: location?.state?.supName
                },
            })
        } else if (location?.state && location?.state?.from?.includes('/suppliers')) {
            setSelectedVendorId(location?.state?.vendorId || null)
            setMatchedSupplierId(location?.state?.matchedSupplierId || null)
            setSelectedVendorInCallsData(location?.state?.vendorInCall)
        }
    }, [location?.state?.IsShowAddCallerDetails])

    useEffect(() => {
        const param = window.location.href.split('lists')?.[1]
        const param1 = window.location.href.split('lists/insequence')?.[1]
        if (param1 && param1?.includes('editcallerdetails')) {
            setIsEditUnlinkedCalls(true)
        }

        if (param1 && (param1.includes('addcallerdetails') || param1.includes('qacallerdetails')) && (!location?.state || location?.state?.hasOwnProperty('matchedSupplierId'))) {
            let vendorId = param1.includes('addcallerdetails') ? param1.split('/addcallerdetails/')[1] : param1.split('/qacallerdetails/')[1]
            if (vendorId.includes('#')) {
                vendorId = vendorId.split('#')[0]
            } else if (vendorId.includes('voicemailId') || vendorId.includes('matchedSupplierId')) {
                vendorId = vendorId.split('?')[0]
            }
            setCurrentTab('sequence')
            if (param1.includes('qacallerdetails')) {
                setShowQaCallerDetails(true)
            }
            setShowAddCallerDetails(true)
            setSelectedVendorId(vendorId)
        } else if (param === '/insequence') {
            setCurrentTab('sequence')
            setPage(1)
        } else if (param === '/partner-submissions') {
            setSupplierPassedFromNotification(location?.state?.supplierName)
            setCurrentTab('partnerSubmissions')
            setPage(1)
        } else if (param === '') {
            setCurrentTab('list')
            setPage(1)
        }
    }, [window.location.href])

    useEffect(() => {
        if (currentTab === 'list' && page === 1 && !isFilterApplied) {
            let filters = {}
            filters['start_date'] = st_dt
            filters['end_date'] = last_dt
            setIsFilterApplied(true)
            setListFilters(filters)
            getListSuppliersData(limit, limit * (page - 1), filters)
        } else if (window?.location?.pathname === '/lists' && page !== 1 && isFilterApplied) {
            getListSuppliersData(limit, limit * (page - 1), listFilters)
        } else if (window?.location?.pathname === '/lists' && !isFilterApplied) {
            getListSuppliersData(limit, limit * (page - 1), {})
        }
    }, [page, limit, currentTab])

    useEffect(() => {
        const param = window.location.href.split('lists/insequence')[1]
        const param1 = window.location.href.split('lists')?.[1]
        if (!param) {
            if (currentTab === 'list' && (param1 === '' || !param1)) {
                history.push('/lists')
            }
            if (currentTab === 'sequence' && param1 === '/insequence') {
                getInSequenceSuppliersData(inCallsFilters)
            }
            if (currentTab === 'partnerSubmissions' && param1 === '/partner-submissions') {
                setIsFilterApplied(true)
                setPartnerSubFilters({ 'currentStatus': currentStatuses });
            }
            setPage(1)
        }
    }, [currentTab])

    useEffect(() => {
        showContextMenuItems()
    }, [currentTab])

    useEffect(() => {
        if (currentTab === 'sequence') {
            if (Object.keys(inCallsFilters).length !== 0 && activeKey === 'generalCalls') {
                getInSequenceSuppliersData({})
            }
            handleResetFilterClick()
        }
    }, [activeKey])

    return (
        <div id="my-lists-page" className={`my-lists-page padding-left bg-white `}>
            <div className='current-page-title d-flex align-items-center'>
                {(showAddCallerDetails || showQaCallerDetails || isEditUnlinkedCalls) ? <div><MdOutlineArrowBackIosNew className='me-2' color="#78B1E4" size={20} onClick={() => { handleGoBackButtonClick() }} /> {showQaCallerDetails ? 'QA' : matchedSupplierId ? 'Confirm' : isEditUnlinkedCalls ? 'Edit' : 'Add'} Caller Details</div> : 'My Lists'}
            </div>
            {(!showAddCallerDetails) && (<div className="page-tabs gap-4 gap-md-5">
                {
                    tabs.map(tab => {
                        if (tab.value === 'sequence' && !isAdminOrMod && !user?.isCaller) {
                            return
                        }
                        if (!isAdminOrMod && tab.value === 'partnerSubmissions') {
                            return
                        }
                        return <button
                            key={tab.value}
                            type="button"
                            className={`page-tab me-0${currentTab === tab.value ? ' selected' : ''}`}
                            onClick={() => { handleClickTab(tab.value) }}
                        >
                            {tab.label}
                        </button>
                    })
                }
                <div className='ms-auto position-relative flex-grow-1'>
                    {!showFilters && (
                        <button className={`ms-4 p-3 ps-4 pe-4 text-white h5 mb-0 rounded float-end${!isFilterApplied ? ' bg-gray' : ' bg-green'}`} onClick={handleResetFilterClick} disabled={!isFilterApplied}> Reset Filter </button>
                    )}
                    <button className='bg-gray p-3 ps-4 pe-4 text-white h5 mb-0 rounded float-end' onClick={handleAddFilterClick}> + Add Filter </button>
                    {showFilters && (
                        <div className='position-absolute top-100 end-0 filter-component-parent p-2 w-50 bg-white rounded shadow'>
                            <FilterComponent
                                columns={currentTab === 'list' ? listFilterColumns : currentTab === 'sequence' ? activeKey === 'generalCalls' ? callsFilterColumns : reenablementFilterColumn : partnerSubFilterColumns}
                                filterValues={currentTab === 'list' ? listFilters : currentTab === 'sequence' ? activeKey === 'generalCalls' ? inCallsFilters : inReenablementFilters : partnerSubFilters}
                                onChangeFilters={(value, optionName) => { handleFiltersChange(value, optionName) }}
                                onCancel={() => { handleCancelClick() }}
                                onApplyFilter={() => { handleApplyFilterClick() }}
                                vendorsInCalls={currentTab === 'sequence' ? callsTableData : []}
                                tab={currentTab}
                            />
                        </div>
                    )}
                </div>
            </div>
            )}
            {showStopModal && (
                <Modal
                    backdrop={'static'}
                    className="link-to-vendor-modal"
                    show={showStopModal}
                    size="lg"
                    onHide={() => { setShowStopModal(false) }}
                >
                    <Modal.Header>
                        <Modal.Title className='text-black fw-bold text-wrap'>
                            You have selected to force stop enablement for this entire list. The suppliers will automatically be sent to QA with the acceptance details that are currently gathered. Are you sure you want to stop the enablement campaign?
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='mt-4 h-75'>

                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="me-3 h4 mb-0 pt-2 pb-2 bg-gray text-white width-100 rounded"
                            onClick={() => { setShowStopModal(false) }}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="h4 mb-0 pt-2 pb-2 btn-green width-100 rounded"
                            onClick={() => { stopOrResumeListHandler('stop') }}
                        >
                            Confirm
                        </button>
                    </Modal.Footer>
                </Modal>
            )}

            {(!showAddCallerDetails) && currentTab === 'list' && (
                <>
                    <Modal show={openModal} onClose={closeErrorListModal} onHide={closeErrorListModal}>
                        <Modal.Header>
                            <Modal.Title className='fw-semibold'>{isDeleteList ? 'Delete' : 'Failed List Errors'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <h4>{!isDeleteList ? (
                                <ol>
                                    {errorLogForList?.logs?.map((errors) => <li className='my-2'> {errors?.logMessage}</li>)}
                                </ol>
                            ) : 'Are you sure you want to delete  failed list ? List Suppliers associated to this list will be deleted too '}</h4>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='d-flex column-gap-2 justify-content-end'>
                                {isDeleteList && <button
                                    className='bg-red p-3 ps-4 pe-4 text-white h5 mb-0 rounded float-end'
                                    onClick={() => { onDeleteFailedList(errorLogForList?.listId) }}
                                    style={{ width: '94px' }}
                                >
                                    Delete
                                </button>}

                                <button
                                    onClick={closeErrorListModal}
                                    className='bg-gray p-3 ps-4 pe-4 text-white h5 mb-0 rounded float-end '
                                    style={{ width: '94px' }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <div className={`position-relative mt-4 border border-2 rounded ${isLoadingLists ? 'loading' : ''}`}>
                        {isLoadingLists && <LoaderComponent />}
                        <Table
                            virtualized={true}
                            autoHeight
                            affixHeader={true}
                            data={listTableData}
                            className='my-list-table'
                            id='my-list-table'
                            rowKey="id"
                        >
                            {headerElements(dbMatchTableColumns)}
                            <Column
                                resizable
                                width={100}
                                key={'progress'}
                            >
                                <HeaderCell className='fw-bold text-black'>{'Progress'}</HeaderCell>
                                <Cell className='listProgress listCellContainer'>
                                    {
                                        rowData => {
                                            return (
                                                <div className={`listProgressContainer`} style={{ width: 40 }}>
                                                    <Progress.Circle percent={parseFloat(rowData?.progress).toFixed(1)} style={{ fontSize: 10 }} />
                                                </div>

                                            )
                                        }
                                    }
                                </Cell>
                            </Column>
                            <Column width={200} key={'autoMasterCreateProgress'}>
                                <HeaderCell className='fw-bold text-black'>Auto Create Master Progress</HeaderCell>
                                <Cell className='listProgress listCellContainer'>
                                    {rowData => {
                                        if (rowData?.autoMasterCreateProgress < 100) {
                                            return (
                                                <div className={`listProgressContainer`} style={{ width: 40 }}>
                                                    <Progress.Circle percent={parseFloat(rowData?.autoMasterCreateProgress).toFixed(2)} style={{ fontSize: 10 }} />
                                                </div>
                                            )
                                        }
                                    }}
                                </Cell>
                            </Column>
                            <Column width={100} id='actionbtn'>
                                <HeaderCell className='d-none'>Error</HeaderCell>
                                <Cell>
                                    {rowData => {
                                        if (rowData.status === "Failed") {
                                            return (
                                                <button className='bg-gray p-3 ps-4 pe-4 text-white h5 mb-0 rounded float-end w-100 mb-0' onClick={() => { openModalHandler('viewError', { listId: rowData?.id, logs: rowData?.logs }) }} > Error</button>
                                            )
                                        }
                                    }}
                                </Cell>
                            </Column>
                            <Column width={100} id='actionbtn'>
                                <HeaderCell className='d-none'>Error</HeaderCell>
                                <Cell className='table-action' style={{ display: 'flex', alignItems: 'center' }}>
                                    {rowData => {
                                        if (rowData.status === "Failed") {
                                            return isAdminOrMod ? <button className='bg-red p-3 ps-4 pe-4 text-white h5  rounded float-end w-100 mb-0' onClick={() => { openModalHandler('delete', { listId: rowData?.id, errorMsg: rowData?.log?.logMessage }) }}>Delete</button> : null
                                        }
                                    }}
                                </Cell>
                            </Column>
                        </Table>
                        <div className="my-list-table-pagination">
                            <Pagination
                                prev
                                next
                                first={true}
                                last={true}
                                maxButtons={5}
                                activePage={page}
                                showInfo
                                displayLength={limit}
                                lengthMenu={[
                                    {
                                        label: '10',
                                        value: 10,
                                    },
                                    {
                                        label: '20',
                                        value: 20,
                                    },
                                    {
                                        label: '30',
                                        value: 30,
                                    },
                                    {
                                        label: '50',
                                        value: 50,
                                    },
                                    {
                                        label: '100',
                                        value: 100,
                                    },
                                ]}
                                total={totalLists}
                                onChangeLength={handleChangeLimit}
                                onChangePage={(event) => { setPage(event) }}
                            />
                        </div>
                    </div>
                    {showContextMenu && (
                        <ContextMenu menuItems={isAdminOrMod ? [...selectOptions, ...addSelectOptionIfAdminOrModerator] : selectOptions} onMenuItemClick={handleMenuItemClick} onMenuItemBlur={() => { setShowContextMenu(false) }} selectedCompany={selectedCompany[0]} />
                    )}
                </>
            )
            }
            {
                (!showAddCallerDetails && currentTab === 'sequence' && (isAdminOrMod || user?.isCaller)) && (
                    <InSequenceComponent
                        callsTableColumns={callsTableColumns}
                        unlinkedVendorsTableColumns={unlinkedVendorsTableColumns}
                        tableData={activeKey === 'generalCalls' ? callsTableData : reenablementTableData}
                        onCallClick={handleCallClick}
                        onEditUnlinkedCalls={handleUnlinkedCallsEdit}
                        isLoadingSequenceData={isLoadingCallsData}
                        totalInCallsData={totalInCallsData}
                        getInSequenceSuppliersData={getInSequenceSuppliersData}
                        inCallsFilters={inCallsFilters}
                        inReenablementFilters={inReenablementFilters}
                        currentTab={currentTab}
                        reenablementTableColumns={reenablementTableColumns}
                        activeKey={activeKey}
                        setActiveKey={setActiveKey}
                        filterSelected={filterSelected}
                        isFilterApplied={isFilterApplied}
                    />
                )
            }

            {currentTab === 'partnerSubmissions' && (
                <PartnerSubmission
                    ref={partnerSubRef}
                    onTabChange={() => {
                        setPartnerSubFilters({ 'currentStatus': currentStatuses });
                        setIsFilterApplied(true)
                    }}
                    filters={partnerSubFilters}
                    supplierPassedFromNotification={supplierPassedFromNotification}
                />
            )}

            {
                showListInfoModal && (
                    <ListInfoModal
                        show={showListInfoModal}
                        onClose={handleClose}
                        selectedCompany={selectedCompany}
                    />
                )
            }
            {
                isShowMarkCompleteModal && (
                    <MarkCompleteModal
                        show={isShowMarkCompleteModal}
                        onClose={handleMarkCompleteClose}
                        listInfo={selectedCompany?.[0]}
                    />
                )
            }
            {
                showExportModal && (
                    <VendorExportModal
                        show={showExportModal}
                        exportData={exportData}
                        onClose={(status) => {
                            handleExportClose(status)
                        }}
                        fileName={exportFileName}
                    />
                )
            }
            {
                showSendToCallsModal && (
                    <SendToCallsModal
                        show={showSendToCallsModal}
                        handleClose={onSendToCallsModalClose}
                        columns={sendToCallsColumns}
                        selectedCompanyDetails={selectedCompany[0]}
                        listId={selectedCompany?.[0]?.id} //remove list id, partnerid, selected company, supplier matched, selected company status as sending selectedCompany details here
                        partnerId={selectedCompany?.[0]?.partnerId}
                        selectedCompany={selectedCompany[0]?.companyName}
                        suppliersMatched={selectedCompany[0]?.suppliersMatched || 0}
                        selectedCompanyStatus={selectedCompany[0]?.status}
                        isFromMarkListComplete={isFromMarkListComplete}
                    />
                )
            }
            {
                (showAddCallerDetails || showQaCallerDetails || isEditUnlinkedCalls) && (
                    <AddCallerDetails
                        vendorInCallsData={selectedVendorInCallsData}
                        vendorId={selectedVendorId}
                        vendorInCallsDetailsId={vendorInCallsDetailsId}
                        type={showQaCallerDetails ? 'qa' : isEditUnlinkedCalls ? 'edit' : 'call'}
                        onClose={handleAddCallerDetailsClose}
                        callsTableData={callsTableData}
                        supplierId={matchedSupplierId}
                        activeKey={activeKey}
                    />
                )
            }

            {showReRunModal && (
                <ModalComponent
                    backdrop={'static'}
                    open={showReRunModal}
                    handleClose={handleReRunModalClose}
                    modalTitle='Rerun Matching'
                    size={`md`}
                    isLoading={isLoading}
                >
                    <h4 className='mb-0 text-black fw-bold m-auto'>
                        <p className='text-center'>Are you sure you want to Rerun Matching for Unmatched List Suppliers?</p>
                        <h4 className='text-center'>Total List Suppliers: {reRunListSuppliers?.length}</h4>
                    </h4>
                    <div className='mt-4'>
                        <button
                            className='me-3 pt-2 pb-2 h4 mb-0 fw-bold rounded bg-red text-white width-100'
                            disabled={isLoading}
                            onClick={() => { handleReRunModalClose() }}
                        >
                            No
                        </button>
                        <button
                            className='pt-2 pb-2 h4 mb-0 fw-bold rounded btn-green text-white ms-auto width-100'
                            disabled={isLoading || reRunListSuppliers?.length === 0}
                            onClick={() => { reRunUnmatchedListSuppliers() }}
                        >
                            Yes
                        </button>
                    </div>
                </ModalComponent>
            )}

            {showReportDownloadModal && (
                <Modal
                    backdrop={false}
                    className="matched-child-list-modal"
                    show={showReportDownloadModal}
                    size="sm"
                    onHide={handleCloseModal}
                >
                    <Modal.Header>
                        <Modal.Title className="text-black fw-bold fs-4 mb-0">
                            {selectedOption?.label} Download
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{ overflowY: 'auto', maxHeight: '300px' }}>
                        <div className="d-flex flex-column gap-2">
                            {downloadListData.length === 0 && (
                                <div className="text-center text-muted">No Downloading list found.</div>
                            )}

                            {downloadListData.map((data, index) => {
                                return (
                                    <div
                                        key={index}
                                        className="card shadow-sm border-0 p-3"
                                        style={{
                                            transition: 'transform 0.3s, box-shadow 0.3s, border 0.3s, background-color 0.3s',
                                            cursor: 'pointer',
                                            maxWidth: '95%',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.02)';
                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                                            e.currentTarget.style.border = '2px solid #007bff';
                                            e.currentTarget.style.backgroundColor = '#f0f8ff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.1)';
                                            e.currentTarget.style.border = '2px solid transparent';
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }}
                                    >
                                        <div className="card-body d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <h5 className="rs-panel-title mb-0 fs-4 d-flex align-items-center">
                                                    {data?.suppliername || 'No Supplier Name'}
                                                </h5>
                                                <h5 className="btn text-white bg-blue ms-3 mb-0 d-flex align-items-center">
                                                    {data?.listDataInfo?.count || 'N/A'}
                                                </h5>
                                                {data?.isDownloaded && (
                                                    <FaCheck style={{ color: 'green', fontSize: '1.8rem', marginLeft: '8px' }} />
                                                )}
                                            </div>
                                            <button
                                                className="btn btn-success h4 mb-0 fw-bold rounded text-white d-flex align-items-center gap-2"
                                                onClick={() =>
                                                    handleOpenVendor({
                                                        offset: data?.listDataInfo?.offset,
                                                        limit: data?.listDataInfo?.limit,
                                                        index,
                                                        selectedValue: selectedOption?.value
                                                    })
                                                }
                                            >
                                                <MdDownload size={20} />
                                                {data?.isDownloaded ? 'Download Again' : 'Download'}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button
                            className="btn width-100 h4 mb-0 fw-bold rounded text-white btn-secondary"
                            onClick={handleCloseModal}
                        >
                            Close
                        </button>
                    </Modal.Footer>
                </Modal>
            )}
        </div >
    )
}

export default MyListsComponent
